var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatabases(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 260.39 244.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#1b2d3b"
    },
    x: 96.87,
    y: 30.91,
    width: 66.65,
    height: 66.65,
    transform: "translate(-7.29 110.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1b2d3b"
    },
    d: "M199.38,156.32l-45.7-45.7-23.49,23.49-23.48-23.49L61,156.32a1.5,1.5,0,0,0,0,2.13l68.12,68.12a1.5,1.5,0,0,0,2.13,0l68.12-68.12A1.5,1.5,0,0,0,199.38,156.32Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabases);
export default __webpack_public_path__ + "static/media/databases.28f4661c4909e56de1246f01abcbc466.svg";
export { ForwardRef as ReactComponent };